var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 4.8668L12.3206 3.17314V1H8.92859L8.93802 3.17785L10.627 4.8668Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56272 11.934H2.00049C2.12563 13.901 2.90854 15.6889 4.1321 17.0804L8.77174 12.4408C8.67936 12.2798 8.60978 12.1094 8.56272 11.934Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92004 17.8683C6.31176 19.0921 8.10007 19.8751 10.0674 20V13.438C9.89173 13.3909 9.72093 13.3213 9.55969 13.2287L4.92004 17.8683Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3452 10.6552C11.1462 10.4562 10.8846 10.3566 10.6232 10.3566C10.3617 10.3566 10.1002 10.4561 9.90113 10.6552C9.50301 11.0534 9.50301 11.7012 9.90113 12.0993C10.2993 12.4974 10.9471 12.4974 11.3452 12.0993C11.7433 11.7011 11.7433 11.0533 11.3452 10.6552Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77188 10.3132L4.1322 5.67352C2.90853 7.06487 2.12529 8.85277 2 10.8197H8.56283C8.60993 10.6444 8.6795 10.474 8.77188 10.3132Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1818 13.4372V19.9998C13.1482 19.8743 14.9356 19.0914 16.3268 17.868L11.6872 13.2285C11.5267 13.3206 11.3567 13.3901 11.1818 13.4372Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.475 12.4402L17.1147 17.08C18.338 15.6885 19.1208 13.9008 19.246 11.934H12.6837C12.6367 12.1092 12.5672 12.2794 12.475 12.4402Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0673 9.31641V5.88309L7.82563 3.64142L7.82369 3.19995C6.74337 3.56969 5.7598 4.14774 4.92029 4.88574L9.55997 9.52542C9.7211 9.433 9.89175 9.36343 10.0673 9.31641Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1818 9.3172C11.3565 9.36426 11.5264 9.43365 11.6867 9.52573L16.3263 4.88613C15.49 4.1508 14.5106 3.57431 13.435 3.20435V3.63471L11.1818 5.88797V9.3172Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6834 10.8197H19.2463C19.121 8.85297 18.3379 7.06518 17.1144 5.67395L12.4746 10.3137C12.5669 10.4744 12.6363 10.6446 12.6834 10.8197Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelIcon);
export default __webpack_public_path__ + "static/media/wheel-icon.d97f1497cf9f069349cdeb0d5b2051e6.svg";
export { ForwardRef as ReactComponent };